/* eslint-disable react/prop-types */
import { Result } from 'antd';

import { Container } from 'react-bootstrap';

import Button from 'src/components/Button';


export default function FallbackUI({ id, error }) {
  return (
    <Container style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
    >
      <Result
        status="500"
        title={(
          <div>
            Ops... Ocorreu um erro não tratado
          </div>
        )}
        subTitle={(
          <div>
            <div>
              Id:
              {' '}
              {id}
            </div>
            <div>
              Informe o id acima para o suporte!
            </div>
            <div>
              <p>
                Erro
                {' '}
                {error?.name}
                :
                {' '}
                {error?.message}
              </p>
            </div>
          </div>
        )}
        extra={(
          <Button
            type="primary"
          >
            <a
              style={{ textDecoration: 'none', color: '#fff' }}
              href={process.env.REACT_APP_BASE_ROUTE}
            >
              Voltar para página inicial
            </a>
          </Button>
        )}
      />
    </Container>
  );
}
